import { useIsMutating } from '@tanstack/react-query';
import { Button, Modal, Space } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useParams } from 'react-router-dom';
import { t } from 'ttag';

import ConnectionForm, { ADD_CONNECTION_FORM_ID } from './AddForm';
import { addConnectionMutationOptions } from './queries';

const AddModal = ({ onClose }) => {
  const { organizationId } = useParams();

  const isAdding = !!useIsMutating(addConnectionMutationOptions(organizationId));

  return (
    <Modal
      title={t`Add Connection`}
      open
      mask={{ closable: false }}
      destroyOnHidden
      onCancel={onClose}
      footer={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Space>
            <Button onClick={onClose} disabled={isAdding}>
              {t`Cancel`}
            </Button>
          </Space>
          <Space>
            <Button
              type="primary"
              htmlType="submit"
              form={ADD_CONNECTION_FORM_ID}
              loading={isAdding}
            >
              {t`Add Connection`}
            </Button>
          </Space>
        </div>
      }
      width={700}
    >
      <Space size="large" orientation="vertical" style={{ width: '100%' }}>
        <ConnectionForm onSuccess={onClose} />
      </Space>
    </Modal>
  );
};

AddModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default AddModal;
